module.exports = __webpack_public_path__ + "static/media/independent.68677f8a.jpg";